<template>
    <div class="ObjectsPreviewList">
        <div class="ObjectsPreviewList__header">
            <div class="ObjectsPreviewList__close" @click="$emit('close')">
                <CloseIcon/>
            </div>
            <!--<div class="ObjectsPreviewList__name">{{name}}</div>
            <div class="ObjectsPreviewList__location">{{location}}</div>-->
            <div class="ObjectsPreviewList__offers">{{getOffersString(objects.length)}} </div>
        </div>
        <div class="ObjectsPreviewList__objects-wrapper">
            <div class="ObjectsPreviewList__objects">
                <ObjectMapPreview
                        v-for="(object, index) of objects"
                        v-bind="object"
                        :key="index"
                        :name="object.name"
                        :location="object.location"
                />
            </div>
        </div>
    </div>
</template>

<script>
import CloseIcon from '@/assets/image/icons/close.svg?inline'
import ObjectMapPreview from "@/components/Object/ObjectMapPreview";

export default {
    name: "ObjectsPreviewList",
    props: {
        name: String,
        location: String,
        objects: Array,
    },
    components: {
        CloseIcon,
        ObjectMapPreview,
    },
    methods: {
        getOffersString(str) {
            str = str+'';
            let arr = str.split('');
            let char = arr[arr.length - 1];
            let suffix = 'ий';

            if (str * 1 > 4 && str * 1 < 15) {
                suffix = 'ий';
            }
            else if (char === '1'){
                suffix = 'ие';
            } else if (char === '2' || char === '3' || char === '4') {
                suffix = 'ия';
            }

            return str + ' предложен' + suffix;
        }
    }
}
</script>

<style lang="scss">
.ObjectsPreviewList {
  display: flex;
  flex-direction: column;
  max-height: 100%;
  position: relative;

  &__header {
    padding: 48px 16px 20px;
    box-shadow: $BlockShadow;
  }

  &__name {
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
  }

  &__location {
    font-weight: 300;
    margin-bottom: 12px;
  }

  &__offers {

  }

  &__objects-wrapper {
    overflow-y: auto;
    max-height: 100%;
  }

  &__close {
    cursor: pointer;
    position: absolute;
    top: 16px;
    right: 16px;
    @include svgFill($primary);
  }
}
</style>